var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import RadioPrimaryButton from '@declaration/components/UI/RadioPrimaryButton.vue';
import BreakInDamageDescriptionSectionCard from '@declaration/components/breakInDamage/DamageDescription/UI/BreakInDamageDescriptionSectionCard.vue';
import BreakInDamageDescriptionStep from '@declaration/components/breakInDamage/DamageDescription/UI/BreakInDamageDescriptionStep.vue';
import BreakInDamageChoices from '@declaration/components/breakInDamage/DamageDescription/UI/BreakInDamageChoices.vue';
import { OTHER_DAMAGE_TYPE_TRAD_KEYS_AND_IMAGES } from '@shared/constants/breakInDamages/OtherConstants';
import BreakInDamageDescriptionSubSection from '@declaration/components/breakInDamage/DamageDescription/UI/BreakInDamageDescriptionSubSection.vue';
import { OtherDamageType as OtherDamageTypeEnum } from '@shared/types/api/breakInDamage';
const layout = namespace('layout');
const breakInDamage = namespace('breakInDamage');
let OtherDamageType = class OtherDamageType extends Vue {
    constructor() {
        super(...arguments);
        this.showValidation = false;
        this.otherDamageTypes = Object.entries(OTHER_DAMAGE_TYPE_TRAD_KEYS_AND_IMAGES).map(([otherDamageType, description]) => ({
            value: otherDamageType,
            tradKey: description.tradKey,
            image: description.image,
        }));
    }
    get change() {
        return this.changeGetter(this.changeKey);
    }
    get breakInDamage() {
        return this.change.data;
    }
    get validation() {
        return this.validationGetter(this.changeKey);
    }
    get isValid() {
        return (!this.validation.fieldHasViolations('otherDamageType') &&
            !this.validation.fieldHasViolations('otherDamageName'));
    }
    update(data) {
        this.updateBreakInDamage({ changeKey: this.changeKey, data });
    }
    save() {
        this.$emit('goToNextStep');
    }
    revealValidation() {
        this.$store.dispatch('error/add', this.$tc('error.form.please_validate_message'));
        this.validateBreakInDamage(this.changeKey);
        this.showValidation = true;
    }
    get displayDamageNameQuestion() {
        return (this.breakInDamage.otherDamageType != null &&
            this.breakInDamage.otherDamageType === OtherDamageTypeEnum.Other);
    }
};
__decorate([
    layout.State('color')
], OtherDamageType.prototype, "color", void 0);
__decorate([
    breakInDamage.Getter('change')
], OtherDamageType.prototype, "changeGetter", void 0);
__decorate([
    breakInDamage.Action('updateDamage')
], OtherDamageType.prototype, "updateBreakInDamage", void 0);
__decorate([
    breakInDamage.Getter('validation')
], OtherDamageType.prototype, "validationGetter", void 0);
__decorate([
    breakInDamage.Action('validateAndRevealDamages')
], OtherDamageType.prototype, "validateBreakInDamage", void 0);
OtherDamageType = __decorate([
    Component({
        components: {
            BreakInDamageChoices,
            RadioPrimaryButton,
            BreakInDamageDescriptionSectionCard,
            BreakInDamageDescriptionStep,
            BreakInDamageDescriptionSubSection,
        },
        props: {
            changeKey: { type: [String, Number], default: null },
            isFinalStep: { type: Boolean, default: false },
            isSaving: { type: Boolean, default: false },
        },
    })
], OtherDamageType);
export default OtherDamageType;
